module.exports = __webpack_public_path__ + "static/media/AML-Penalties-v1.ab734522.svg";